import { configureStore } from '@reduxjs/toolkit';
import localizationSlice from '../features/localization/LocalizationSlice';
import errorMessageSlice from '../features/Errors/ErrorsSlice';
import userSlice from '../features/User/UserSlice';
import leftMenuSlice from '../features/LeftMenu/LeftMenu';
import topMenuSlice from '../features/TopMenu/TopMenu';
import modalSlice from '../features/Modal/Modal';
import sidebarSlice from '../features/Sidebar/Sidebar';
import companySlice from '../features/Company/CompanySlice';
import categoriesSlice from '../features/Categories/Category';
import brokerSlice from '../features/Broker/BrokerSlice';
import brokerSignupSlice from '../features/BrokerSignup/BrokerSignupSlice';
import brokerRegisterSlice from '../features/BrokerRegister/BrokerRegisterSlice';
import companyStructureSlice from '../features/CompanySubQuestion/CompanySubQuestion';
import toastSlice from '../features/Toast/ToastSlice';
import onePageMenuSlice from '../features/OnePageMenu/OnePageMenuSlice';
import shareHolderDistributionSlice from '../features/ShareholderDistributionSubQuestion/ShareholderSlice';
import revenuePercentageSlice from '../features/RevenuePercentageSubQuestion/RevenuePercentageSlice';
import revenueActivityDistributionSlice from '../features/RevenueActivityDistributionSubQuestion/RevenueActivityDistribution';
import industriesPercentageSlice from '../features/IndustryPercentageSubQuestion/IndustryPercentageSlice';
import publicIpafSlice from '../features/PublicIpaf/PublicIpafSlice';
import controlCoverageLimitsSubQuestionSlice from '../features/ControlCoverageLimitsSubQuestion/ControlCoverageLimitsSubQuestion';
import checkoutSlice from '../features/Checkout/CheckoutSlice';
import countryCoverageLimitsSlice from '../features/CountryCoverageLimits/CountryCoverageLimits';
import ipafResultSlice from '../features/IpafResult/IpafResultSlice';
import selectedCheckoutSlice from '../features/SelectedCheckout/SelectedCheckoutSlice';
import companyDetailSlice from '../features/CompanyDetail/CompanyDetailSlice';
import insuranceProductsSlice from '../features/InsuranceProducts/InsuranceProductsSlice';
import hashesOfIpaf from '../features/PublicIpaf/HashesOfIpaf';
import formsSlice from '../features/Forms/FormsSlice';

export const store = configureStore({
	reducer: {
		localization: localizationSlice,
		error: errorMessageSlice,
		user: userSlice,
		leftMenu: leftMenuSlice,
		topMenu: topMenuSlice,
		modal: modalSlice,
		sidebar: sidebarSlice,
		company: companySlice,
		categories: categoriesSlice,
		companyStructure: companyStructureSlice,
		toast: toastSlice,
		broker: brokerSlice,
		brokerSignup: brokerSignupSlice,
		brokerRegister: brokerRegisterSlice,
		onePageMenu: onePageMenuSlice,
		shareholderDistribution: shareHolderDistributionSlice,
		revenuePercentage: revenuePercentageSlice,
		revenueActivityDistribution: revenueActivityDistributionSlice,
		industryPercentage: industriesPercentageSlice,
		publicIpaf: publicIpafSlice,
		controlCoverageLimitsSubQuestion: controlCoverageLimitsSubQuestionSlice,
		checkout: checkoutSlice,
		countryCoverageLimits: countryCoverageLimitsSlice,
		ipafResult: ipafResultSlice,
		selectedCheckout: selectedCheckoutSlice,
		companyDetail: companyDetailSlice,
		insuranceProducts: insuranceProductsSlice,
		publicHashes: hashesOfIpaf,
		forms: formsSlice,
	},
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
